export default __webpack_public_path__ + "static/media/seven.3044c197.svg";